export function getLocale() {
  if (window.location.pathname.startsWith("/de") || process.env.VUE_APP_DEFAULT_LANGUAGE === "de") return "de";
  else if (window.location.pathname.startsWith("/en")) return "en";

  if (navigator?.language?.startsWith("de")) return "de";

  return "en";
}